import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '~/state/store'

export const getPackages = (state: AppState) => state.package.packages

export const hasLoadingPackages = (state: AppState) => state.package.loading

export const getFeatures = (state: AppState) => state.package.features

export const getPackageId = (state: AppState) => state.package.id

export const getPackage = createSelector(
  getPackages,
  getPackageId,
  (packages, id) => packages.find((p) => p.id === String(id))
)

export const getTotalPackage = createSelector(
  getPackage,
  getFeatures,
  (currentPackage, features) => {
    if (!currentPackage?.advanced_features) return 0

    return currentPackage?.advanced_features?.reduce((acc, { price, id }) => {
      if (features?.includes(+id)) {
        // eslint-disable-next-line no-param-reassign
        acc += price?.cents
      }

      return acc
    }, currentPackage?.price?.cents)
  }
)

export const getTotalFeature = createSelector(
  getPackage,
  getFeatures,
  (currentPackage, features) => {
    if (!currentPackage?.advanced_features) return 0

    return currentPackage?.advanced_features?.reduce((acc, { price, id }) => {
      if (features?.includes(+id)) {
        // eslint-disable-next-line no-param-reassign
        acc += price?.cents
      }

      return acc
    }, 0)
  }
)

export const getPackageFeatures = createSelector(
  getPackage,
  getFeatures,
  (currentPackage, features) =>
    currentPackage?.advanced_features?.filter((f) => features?.includes(+f.id))
)
